import script from "./GeneratePortfolio.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneratePortfolio.vue?vue&type=script&setup=true&lang=js"

import "./GeneratePortfolio.vue?vue&type=style&index=0&id=01b547a8&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01b547a8"]])

export default __exports__